import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective } from '@nk/ui-lib';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ButtonColor } from '../../directives/button.utils';

@Component({
  selector: 'nk-confirm-or-cancel-modal',
  imports: [TranslateModule, ButtonDirective],
  templateUrl: './confirm-or-cancel-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmOrCancelModalComponent {
  // TODO: move it to ui-lib

  // Inputs using input() function with proper typing
  public text = '';
  public title = '';
  public mainBtnLabel = '';
  public mainBtnColor: ButtonColor = 'primary';
  public secondaryBtnColor: ButtonColor = 'secondary';

  // Output for confirmation result
  public isConfirmed = false;

  private _modalService = inject(BsModalService);

  public close(confirm: boolean): void {
    this.isConfirmed = confirm;
    this._modalService.hide();
  }
}
